import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const fileManagerUploadFileFn = ({ formData, customerId }) =>
  apiClient.post(`${APP_API_URL}file-manager/upload-file?customer_id=${customerId}`, formData, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });

export const useFileManagerUploadFileMutation = (props) => {
  return useMutation({
    mutationFn: fileManagerUploadFileFn,
    onSuccess: ({ data }) => {
      props?.onSuccess && props.onSuccess(data);
    },
    onError: (data, variables) => {
      props?.onError && props.onError(variables);
    },
  });
};
